import { inject, computed, ref, useSlots, toRef, watch, openBlock, createElementBlock, renderSlot, createTextVNode, toDisplayString, createCommentVNode, createBlock, withCtx, createVNode, createElementVNode, normalizeClass, withDirectives, vModelDynamic, unref } from "vue";
import { useField } from "vee-validate";
import ErrorIcon from "../../uikit.icons/ErrorIcon.vue.es.js";
import SuccessIcon from "../../uikit.icons/TickIcon.vue.es.js";
import WarningIcon from "../../uikit.icons/WarningIcon.vue.es.js";
import TooltipIcon from "../../uikit.icons/TooltipIcon.vue.es.js";
import UikitDropdown from "../Dropdown.vue.es.js";
import UikitSkeleton from "../Skeleton.vue.es.js";
import Loader from "../Loader.vue.es.js";
import { INPUT_PROPS } from "./input.es.js";
/* empty css                 */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = ["for"];
const _hoisted_2 = {
  key: 0,
  class: "required-mark"
};
const _hoisted_3 = {
  key: 0,
  class: "prefix"
};
const _hoisted_4 = ["id", "type", "name", "placeholder", "disabled", "inputmode", "min", "max"];
const _hoisted_5 = {
  key: 1,
  class: "suffix"
};
const _hoisted_6 = {
  key: 2,
  class: "status-icon"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 2,
  class: "uikit-input-warning"
};
const _sfc_main = {
  __name: "InputNew",
  props: {
    ...INPUT_PROPS,
    standalone: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "onBlur", "onChange", "onFocus"],
  setup(__props, { emit: __emit }) {
    const INPUT_STATUS = {
      NONE: "none",
      ERROR: "error",
      WARNING: "warning",
      SUCCESS: "success",
      LOADING: "loading"
    };
    const emit = __emit;
    const props = __props;
    const isFormDisabled = inject("isFormDisabled", false);
    const isFormSkeleton = inject("isFormSkeleton", false);
    const displaySkeleton = computed(() => isFormSkeleton.value || props.skeleton);
    const input = ref(props.inputRef);
    const slots = useSlots();
    const hasTooltip = computed(() => props.tooltip || !!slots.tooltip);
    const name = toRef(props, "name");
    const {
      value: formValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
      validate
    } = useField(name, props.rules, {
      initialValue: props.modelValue && props.valueFormatter ? props.valueFormatter(props.modelValue) : props.modelValue,
      syncVModel: props.syncVModel,
      standalone: props.standalone
    });
    const displayedValue = ref(
      props.displayedValueFormatter ? props.displayedValueFormatter(formValue.value) : formValue.value
    );
    const status = computed(() => {
      if (errorMessage.value) {
        return INPUT_STATUS.ERROR;
      } else if (slots.warning) {
        return INPUT_STATUS.WARNING;
      } else {
        return INPUT_STATUS.NONE;
      }
    });
    const isError = computed(() => status.value === INPUT_STATUS.ERROR);
    const isWarning = computed(() => status.value === INPUT_STATUS.WARNING);
    const isSuccess = computed(() => status.value === INPUT_STATUS.SUCCESS);
    const isDisabled = computed(() => isFormDisabled.value || props.disabled);
    const isLoading = computed(() => props.loading);
    const isHidden = computed(() => props.type.toLowerCase() === "hidden");
    const hasStatusIcon = computed(() => isError.value || isSuccess.value || isLoading.value);
    const inputWrapperClasses = computed(() => ({
      "uikit-input-wrapper-error": isError.value,
      "uikit-input-wrapper-success": isSuccess.value,
      "uikit-input-wrapper-warning": isWarning.value,
      "uikit-input-wrapper-disabled": isDisabled.value,
      "uikit-input-wrapper-hidden": isHidden.value
    }));
    const handleFieldBlur = (e) => {
      emit("onBlur", e);
      handleBlur(e);
      if (meta.touched && !meta.dirty && !meta.validated) {
        validate();
      }
    };
    const handleFocus = (e) => {
      emit("onFocus", e);
    };
    const handleFieldChange = (value, fromModelValue) => {
      emit("onChange", value);
      let internalValue = value;
      if (props.valueFormatter) {
        internalValue = props.valueFormatter(internalValue);
      }
      if (!fromModelValue || internalValue !== value) {
        emit("update:modelValue", internalValue);
      }
      handleChange(internalValue);
      displayedValue.value = props.displayedValueFormatter ? props.displayedValueFormatter(value) : formValue.value;
    };
    const handleInputChange = (e) => {
      handleFieldChange(e.target.value, false);
    };
    watch(
      () => props.modelValue,
      (newValue) => {
        if (formValue.value !== newValue) {
          handleFieldChange(newValue, true);
        }
      }
    );
    watch(
      () => formValue.value,
      (newValue) => {
        handleFieldChange(newValue, true);
      }
    );
    const handleInputClick = () => {
      var _a;
      return (_a = input == null ? void 0 : input.value) == null ? void 0 : _a.focus();
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "uikit-input",
        onClick: handleInputClick
      }, [
        _ctx.label ? (openBlock(), createElementBlock("label", {
          key: 0,
          class: "uikit-input-label",
          for: _ctx.id
        }, [
          renderSlot(_ctx.$slots, "label", {}, () => [
            createTextVNode(toDisplayString(_ctx.label) + " ", 1),
            _ctx.required ? (openBlock(), createElementBlock("span", _hoisted_2, " * ")) : createCommentVNode("", true)
          ], true),
          hasTooltip.value ? (openBlock(), createBlock(UikitDropdown, { key: 0 }, {
            overlay: withCtx(() => [
              renderSlot(_ctx.$slots, "tooltip", {}, () => [
                createTextVNode(toDisplayString(_ctx.tooltip), 1)
              ], true)
            ]),
            default: withCtx(() => [
              createVNode(TooltipIcon, { class: "tooltip-icon" })
            ]),
            _: 3
          })) : createCommentVNode("", true)
        ], 8, _hoisted_1)) : createCommentVNode("", true),
        createVNode(UikitSkeleton, {
          type: "input",
          loading: displaySkeleton.value
        }, {
          default: withCtx(() => [
            createElementVNode("div", {
              class: normalizeClass(["uikit-input-wrapper", inputWrapperClasses.value])
            }, [
              _ctx.$slots.prefix ? (openBlock(), createElementBlock("span", _hoisted_3, [
                renderSlot(_ctx.$slots, "prefix", {}, void 0, true)
              ])) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "input", {
                inputValue: displayedValue.value,
                handleFieldChange,
                handleInputChange,
                handleFieldBlur
              }, () => [
                withDirectives(createElementVNode("input", {
                  id: _ctx.id,
                  ref_key: "input",
                  ref: input,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => displayedValue.value = $event),
                  type: _ctx.type,
                  name: name.value,
                  placeholder: _ctx.placeholder,
                  disabled: isDisabled.value,
                  inputmode: _ctx.inputMode,
                  min: _ctx.min,
                  max: _ctx.max,
                  onFocus: handleFocus,
                  onBlur: handleFieldBlur,
                  onChange: handleInputChange,
                  onInput: handleInputChange
                }, null, 40, _hoisted_4), [
                  [vModelDynamic, displayedValue.value]
                ])
              ], true),
              _ctx.$slots.suffix ? (openBlock(), createElementBlock("span", _hoisted_5, [
                renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
              ])) : createCommentVNode("", true),
              hasStatusIcon.value ? (openBlock(), createElementBlock("span", _hoisted_6, [
                isError.value ? (openBlock(), createBlock(ErrorIcon, {
                  key: 0,
                  class: "error-icon",
                  full: true
                })) : isSuccess.value ? (openBlock(), createBlock(SuccessIcon, {
                  key: 1,
                  class: "success-icon"
                })) : isLoading.value ? (openBlock(), createBlock(Loader, {
                  key: 2,
                  show: true,
                  transparent: true,
                  width: "20px",
                  height: "20px",
                  class: "loading-icon"
                })) : createCommentVNode("", true)
              ])) : createCommentVNode("", true)
            ], 2)
          ]),
          _: 3
        }, 8, ["loading"]),
        unref(errorMessage) ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: "uikit-input-error",
          innerHTML: unref(errorMessage)
        }, null, 8, _hoisted_7)) : isWarning.value ? (openBlock(), createElementBlock("div", _hoisted_8, [
          createVNode(WarningIcon, { class: "warning-icon" }),
          renderSlot(_ctx.$slots, "warning", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
};
const UikitInputNew = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-96b43ce0"]]);
export {
  UikitInputNew as default
};
//# sourceMappingURL=InputNew.vue.es.js.map
